export class ListAuditLogsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<AuditLog>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAuditLogsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
